// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file channel.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AccountId, BacktestId, ChannelId } from "./ids_pb";
import { file_ids } from "./ids_pb";
import type { ProviderConfig } from "./configurable_pb";
import { file_configurable } from "./configurable_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file channel.proto.
 */
export const file_channel: GenFile = /*@__PURE__*/
  fileDesc("Cg1jaGFubmVsLnByb3RvEgxjcnlwdG90cmFkZXIipwIKB0NoYW5uZWwSIwoCaWQYASABKAsyFy5jcnlwdG90cmFkZXIuQ2hhbm5lbElkEg8KB3VzZXJfaWQYAiABKAkSDAoEbmFtZRgDIAEoCRITCgtkZXNjcmlwdGlvbhgEIAEoCRIuCghwcm92aWRlchgFIAEoCzIcLmNyeXB0b3RyYWRlci5Qcm92aWRlckNvbmZpZxIPCgdlbmFibGVkGAYgASgIEg4KBnN0YXR1cxgHIAEoCRISCgpzdGF0dXNfbXNnGAggASgJEi4KCmNyZWF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wInIKDENoYW5uZWxJbnB1dBIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEi4KCHByb3ZpZGVyGAMgASgLMhwuY3J5cHRvdHJhZGVyLlByb3ZpZGVyQ29uZmlnEg8KB2VuYWJsZWQYBCABKAgiZgoUVXBzZXJ0Q2hhbm5lbFJlcXVlc3QSIwoCaWQYASABKAsyFy5jcnlwdG90cmFkZXIuQ2hhbm5lbElkEikKBWlucHV0GAIgASgLMhouY3J5cHRvdHJhZGVyLkNoYW5uZWxJbnB1dCI/ChRMaXN0Q2hhbm5lbHNSZXNwb25zZRInCghjaGFubmVscxgBIAMoCzIVLmNyeXB0b3RyYWRlci5DaGFubmVsIqkBCg1DaGFubmVsVXBkYXRlEjYKCHNuYXBzaG90GAEgASgLMiIuY3J5cHRvdHJhZGVyLkxpc3RDaGFubmVsc1Jlc3BvbnNlSAASKQoIdXBzZXJ0ZWQYAiABKAsyFS5jcnlwdG90cmFkZXIuQ2hhbm5lbEgAEioKB2RlbGV0ZWQYAyABKAsyFy5jcnlwdG90cmFkZXIuQ2hhbm5lbElkSABCCQoHcGF5bG9hZCJ6Cg5BY2NvdW50Q2hhbm5lbBIrCgphY2NvdW50X2lkGAEgASgLMhcuY3J5cHRvdHJhZGVyLkFjY291bnRJZBIrCgpjaGFubmVsX2lkGAIgASgLMhcuY3J5cHRvdHJhZGVyLkNoYW5uZWxJZBIOCgZldmVudHMYAyABKA0ifQoPQmFja3Rlc3RDaGFubmVsEi0KC2JhY2t0ZXN0X2lkGAEgASgLMhguY3J5cHRvdHJhZGVyLkJhY2t0ZXN0SWQSKwoKY2hhbm5lbF9pZBgCIAEoCzIXLmNyeXB0b3RyYWRlci5DaGFubmVsSWQSDgoGZXZlbnRzGAMgASgNQkdaRWNvZGViZXJnLm9yZy9DcnlwdG9UcmFkZXIvYXBwL3Byb3RvL2dlbi9jcnlwdG90cmFkZXJwYjtjcnlwdG90cmFkZXJwYmIGcHJvdG8z", [file_ids, file_configurable, file_google_protobuf_timestamp]);

/**
 * @generated from message cryptotrader.Channel
 */
export type Channel = Message<"cryptotrader.Channel"> & {
  /**
   * @generated from field: cryptotrader.ChannelId id = 1;
   */
  id?: ChannelId | undefined;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig provider = 5;
   */
  provider?: ProviderConfig | undefined;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: string status_msg = 8;
   */
  statusMsg: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.Channel.
 * Use `create(ChannelSchema)` to create a new message.
 */
export const ChannelSchema: GenMessage<Channel> = /*@__PURE__*/
  messageDesc(file_channel, 0);

/**
 * @generated from message cryptotrader.ChannelInput
 */
export type ChannelInput = Message<"cryptotrader.ChannelInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig provider = 3;
   */
  provider?: ProviderConfig | undefined;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message cryptotrader.ChannelInput.
 * Use `create(ChannelInputSchema)` to create a new message.
 */
export const ChannelInputSchema: GenMessage<ChannelInput> = /*@__PURE__*/
  messageDesc(file_channel, 1);

/**
 * @generated from message cryptotrader.UpsertChannelRequest
 */
export type UpsertChannelRequest = Message<"cryptotrader.UpsertChannelRequest"> & {
  /**
   * @generated from field: cryptotrader.ChannelId id = 1;
   */
  id?: ChannelId | undefined;

  /**
   * @generated from field: cryptotrader.ChannelInput input = 2;
   */
  input?: ChannelInput | undefined;
};

/**
 * Describes the message cryptotrader.UpsertChannelRequest.
 * Use `create(UpsertChannelRequestSchema)` to create a new message.
 */
export const UpsertChannelRequestSchema: GenMessage<UpsertChannelRequest> = /*@__PURE__*/
  messageDesc(file_channel, 2);

/**
 * @generated from message cryptotrader.ListChannelsResponse
 */
export type ListChannelsResponse = Message<"cryptotrader.ListChannelsResponse"> & {
  /**
   * @generated from field: repeated cryptotrader.Channel channels = 1;
   */
  channels: Channel[];
};

/**
 * Describes the message cryptotrader.ListChannelsResponse.
 * Use `create(ListChannelsResponseSchema)` to create a new message.
 */
export const ListChannelsResponseSchema: GenMessage<ListChannelsResponse> = /*@__PURE__*/
  messageDesc(file_channel, 3);

/**
 * @generated from message cryptotrader.ChannelUpdate
 */
export type ChannelUpdate = Message<"cryptotrader.ChannelUpdate"> & {
  /**
   * @generated from oneof cryptotrader.ChannelUpdate.payload
   */
  payload: {
    /**
     * @generated from field: cryptotrader.ListChannelsResponse snapshot = 1;
     */
    value: ListChannelsResponse;
    case: "snapshot";
  } | {
    /**
     * @generated from field: cryptotrader.Channel upserted = 2;
     */
    value: Channel;
    case: "upserted";
  } | {
    /**
     * @generated from field: cryptotrader.ChannelId deleted = 3;
     */
    value: ChannelId;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message cryptotrader.ChannelUpdate.
 * Use `create(ChannelUpdateSchema)` to create a new message.
 */
export const ChannelUpdateSchema: GenMessage<ChannelUpdate> = /*@__PURE__*/
  messageDesc(file_channel, 4);

/**
 * @generated from message cryptotrader.AccountChannel
 */
export type AccountChannel = Message<"cryptotrader.AccountChannel"> & {
  /**
   * @generated from field: cryptotrader.AccountId account_id = 1;
   */
  accountId?: AccountId | undefined;

  /**
   * @generated from field: cryptotrader.ChannelId channel_id = 2;
   */
  channelId?: ChannelId | undefined;

  /**
   * @generated from field: uint32 events = 3;
   */
  events: number;
};

/**
 * Describes the message cryptotrader.AccountChannel.
 * Use `create(AccountChannelSchema)` to create a new message.
 */
export const AccountChannelSchema: GenMessage<AccountChannel> = /*@__PURE__*/
  messageDesc(file_channel, 5);

/**
 * @generated from message cryptotrader.BacktestChannel
 */
export type BacktestChannel = Message<"cryptotrader.BacktestChannel"> & {
  /**
   * @generated from field: cryptotrader.BacktestId backtest_id = 1;
   */
  backtestId?: BacktestId | undefined;

  /**
   * @generated from field: cryptotrader.ChannelId channel_id = 2;
   */
  channelId?: ChannelId | undefined;

  /**
   * @generated from field: uint32 events = 3;
   */
  events: number;
};

/**
 * Describes the message cryptotrader.BacktestChannel.
 * Use `create(BacktestChannelSchema)` to create a new message.
 */
export const BacktestChannelSchema: GenMessage<BacktestChannel> = /*@__PURE__*/
  messageDesc(file_channel, 6);

